<script>
import VueEasyLightbox from "vue-easy-lightbox";
import LicensesImg from "@img/license/license.webp";
import LicensesFullImg1 from "@img/license/full_license_img/1.webp";
import LicensesFullImg2 from "@img/license/full_license_img/2.webp";
import LicensesFullImg3 from "@img/license/full_license_img/3.webp";
import LicensesFullImg4 from "@img/license/full_license_img/4.webp";
import QR1 from "@img/license/qr-code-1.webp";
import QR2 from "@img/license/qr-code-2.webp";
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import IconZoomGlass from "@js/components/Icons/IconZoomGlass.vue";

export default {
    name: "OfficialLicense",
    components: {IconZoomGlass, IconChevronDown, VueEasyLightbox},
    data() {
        return {
            is_open: false,
            faqs: [
                {
                    question: 'Бетонные плиты высокого качества',
                    answer: 'Мы производим бетонные плиты, соответствующие всем требованиям ГОСТ. Продукция изготовлена из сертифицированных материалов и проходит тщательный контроль качества. Наши плиты выдерживают большие нагрузки и подходят для любого типа строительства: от частных объектов до промышленных площадок.',
                    isOpen: true
                },
                {
                    question: 'Быстрая доставка бетонных плит',
                    answer: 'Организуем доставку бетонных плит по вашему адресу точно в согласованные сроки. Собственный автопарк и профессиональные водители гарантируют безопасность транспортировки и сохранность продукции. Мы обеспечиваем оперативную логистику по вашему региону без лишних задержек.',
                    isOpen: false
                },
                {
                    question: 'Низкие цены на бетонные плиты',
                    answer: 'У нас вы можете купить бетонные плиты по доступной цене. Мы предлагаем прозрачное ценообразование без скрытых комиссий, а также дополнительные скидки для постоянных клиентов. Наши менеджеры помогут рассчитать точную стоимость плит с учетом ваших потребностей.',
                    isOpen: false
                },
                {
                    question: 'Индивидуальный подход и консультации',
                    answer: 'Не знаете, какие бетонные плиты выбрать? Наши специалисты помогут вам подобрать оптимальный вариант под ваши задачи. Мы учтем все параметры вашего строительного проекта и предложим лучшие решения. Покупая у нас, вы получаете не только качественные бетонные плиты, но и профессиональную поддержку.',
                    isOpen: false
                },
            ]
        }
    },
    methods: {
        toggleFAQ(index) {
            this.faqs = this.faqs.map((faq, i) => ({
                ...faq,
                isOpen: i === index ? !faq.isOpen : false
            }));
        }
    },
    setup() {
        return {LicensesImg, LicensesFullImg1, LicensesFullImg2, LicensesFullImg3, LicensesFullImg4, QR1, QR2}
    }
}
</script>

<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div class="order-2 md:order-1">
            <h2 class="text-xl md:text-3xl font-semibold leading-tight mb-5">
                Мы работаем официально
            </h2>
            <p class="text-sm font-medium text-gray-800 mb-5">
                Наша компания ведет деятельность строго в рамках законодательства РФ. Все сделки сопровождаются
                юридически оформленными документами, включая договора, счета и акты. Официальное сотрудничество
                гарантирует вам прозрачность и надежность на всех этапах работы. Покупая бетонные плиты у нас,
                вы получаете качественную продукцию с полным документальным сопровождением.
            </p>
            <div>
                <div v-for="(faq, index) in faqs" :key="index" class="border-b">
                    <button @click="toggleFAQ(index)"
                            class="flex items-center justify-between w-full py-4 font-medium text-start text-gray-800 border-b border-gray-200 gap-3">
                        <span class="text-base font-medium">{{ faq.question }}</span>
                        <IconChevronDown :rotate="faq.isOpen" class="w-4 h-4 shrink-0 text-gray-500"/>
                    </button>
                    <div v-if="faq.isOpen" class="py-5 border-b border-gray-200">
                        <p class="text-sm mb-2 text-gray-800">
                            {{ faq.answer }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-center order-1 md:order-2">
            <div>
                <div class="font-bold text-xl mb-3 text-center">
                    Аттестат аккредитации
                </div>
                <div @click="is_open = true"
                     class="group relative rounded-2xl max-w-full max-h-min overflow-hidden border-2 border-transparent  hover:border-baseColor hover:cursor-pointer transition-all">
                    <img :src="LicensesImg"
                         class="w-full max-h-[300px] h-auto object-cover  transform transition-transform duration-300 group-hover:scale-110 cursor-pointer"
                         alt="license" title="license">
                    <div
                        class="absolute w-full h-full bottom-0 left-0 p-4 text-white uppercase opacity-0 group-hover:opacity-100 bg-white/50 transition-all">
                        <div class="w-full h-full flex items-center justify-center">
                            <IconZoomGlass/>
                        </div>
                    </div>
                </div>
                <div class="mt-5 hidden md:block">
                    <div class="font-bold text-xl mb-3 text-center">
                        Декларации о соответствии
                    </div>
                    <div class="grid grid-cols-2 gap-10">
                        <a href="https://pub.fsa.gov.ru/rds/declaration/view/19693774/common"
                           class="flex items-center justify-center"
                           target="_blank" rel="nofollow" aria-label="qr1" title="qr1">
                            <img :src="QR1" alt="qr1" title="qr1"
                                 class="max-w-[150px]"/>
                        </a>
                        <a href="https://pub.fsa.gov.ru/rds/declaration/view/19693858/common"
                           class="flex items-center justify-center"
                           target="_blank" rel="nofollow" aria-label="qr2" title="qr2">
                            <img :src="QR2" alt="qr2" title="qr2"
                                 class="max-w-[150px]"/>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <VueEasyLightbox :visible="is_open"
                     :imgs="[LicensesFullImg1,LicensesFullImg2,LicensesFullImg3,LicensesFullImg4]"
                     :index="0"
                     @hide="is_open = false"/>
</template>

<style scoped lang="scss">

</style>
